import { propsCallback } from "./blueprint";
export function mapProps(propsMapper) {
  return {
    instanceCallbacks: [propsCallback(function (props) {
      return propsMapper(props);
    })]
  };
}
export default mapProps;